var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgaroseGel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 79,
    viewBox: "0 -5 65 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.4773 0H0V78.9997H64.4773V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M61.9938 2.53179H2.73047V75.7552H61.9955V2.53179H61.9938Z",
    fill: "#7CB4D0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M61.9938 2.53179H2.73047V75.7552H61.9955V2.53179H61.9938Z",
    fill: "#BCDEEA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M2.72931 2.53139L0 0V78.9997L2.72931 75.7548V2.53139ZM61.9935 75.7548L64.4782 78.9997V0L61.9952 2.53139V75.7548H61.9935Z",
    fill: "#7CB4D0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M64.4773 0H0V78.9997H64.4773V0Z",
    fill: "#7CB4D0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M61.9935 75.7304H2.73016L0 79H64.4773L61.9944 75.7304H61.9935Z",
    fill: "#7CB4D0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M4.7373 9.02596H13.8007V5.54063H4.7373V9.02596Z",
    fill: "#3E6E7A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M4.7373 8.44493H13.8007V5.54063H4.7373V8.44578V8.44493Z",
    fill: "#3E6E7A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M4.73791 5.54008L4.06641 4.95905V8.44438L4.72564 9.02541L4.73791 5.54008ZM13.8008 9.02541L14.1366 8.44438V4.95905L13.8008 5.54008V9.02541Z",
    fill: "#3E6E7A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M4.06641 8.44488L4.73791 9.02591H13.8008L14.1366 8.44488H4.06641Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M4.06641 8.44438H14.1366V4.95905H4.06641V8.44438Z",
    fill: "#3E6E7A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.7871 8.44438H25.6808V4.95905H15.7871V8.44438Z",
    fill: "#3E6E7A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M16.4453 9.02596H25.3507V5.54063H16.4453V9.02596Z",
    fill: "#3E6E7A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M16.4464 8.44438H25.3518V5.54008H16.4464V8.44523V8.44438ZM16.4464 5.54008L15.7871 4.95905V8.44438L16.4349 9.02541L16.4464 5.54008ZM25.3518 9.02541L25.6813 8.44438V4.95905L25.3518 5.54008V9.02541Z",
    fill: "#3E6E7A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M15.7861 8.44488L16.4455 9.02591H25.3509L25.6808 8.44488H15.7861Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M27.3291 8.44438H37.2237V4.95905H27.3291V8.44438Z",
    fill: "#3E6E7A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M27.9883 9.02596H36.8937V5.54063H27.9883V9.02596Z",
    fill: "#3E6E7A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M27.9883 8.44493H36.8937V5.54063H27.9883V8.44578V8.44493Z",
    fill: "#3E6E7A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M27.9884 5.54008L27.3291 4.95905V8.44438L27.9768 9.02541L27.9884 5.54008ZM36.8938 9.02541L37.2237 8.44438V4.95905L36.8938 5.54008V9.02541Z",
    fill: "#3E6E7A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M27.3291 8.44488L27.9884 9.02591H36.8938L37.2237 8.44488H27.3291Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M38.873 8.44438H48.7667V4.95905H38.873V8.44438Z",
    fill: "#3E6E7A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M39.5322 9.02596H48.4376V5.54063H39.5322V9.02596Z",
    fill: "#3E6E7A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M39.5324 8.44438H48.4378V5.54008H39.5324V8.44523V8.44438ZM39.5324 5.54008L38.873 4.95905V8.44438L39.5208 9.02541L39.5324 5.54008ZM48.4378 9.02541L48.7672 8.44438V4.95905L48.4378 5.54008V9.02541Z",
    fill: "#3E6E7A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M38.873 8.44488L39.5324 9.02591H48.4378L48.7677 8.44488H38.873Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M50.417 8.44438H60.3116V4.95905H50.417V8.44438Z",
    fill: "#3E6E7A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M51.0762 9.02596H59.9816V5.54063H51.0762V9.02596Z",
    fill: "#3E6E7A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M51.0762 8.44493H59.9816V5.54063H51.0762V8.44578V8.44493Z",
    fill: "#3E6E7A"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M51.0763 5.54008L50.417 4.95905V8.44438L51.0647 9.02541L51.0763 5.54008ZM59.9817 9.02541L60.3116 8.44438V4.95905L59.9817 5.54008V9.02541Z",
    fill: "#3E6E7A"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M50.417 8.44488L51.0763 9.02591H59.9817L60.3116 8.44488H50.417Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgaroseGel);
export default __webpack_public_path__ + "static/media/Agarose_Gel.925ce025cb5f9ddaff6fd6682b7799e3.svg";
export { ForwardRef as ReactComponent };